import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=6884a66c&scoped=true&"
import script from "./slideshow.vue?vue&type=script&lang=js&"
export * from "./slideshow.vue?vue&type=script&lang=js&"
import style0 from "./slideshow.vue?vue&type=style&index=0&id=6884a66c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884a66c",
  null
  
)

export default component.exports